import { useQuery } from "@tanstack/react-query";
import { appointmentService } from "..";

type Props = {
  id: number;
};

const useGetAppointmentDepositById = ({ id }: Props) =>
  useQuery({
    queryKey: ["getAppointmentDepositById", id],
    queryFn: () => appointmentService.getAppointmentDepositDetail(id),
    select: (res) => res,
    enabled: id !== 0,
  });

export { useGetAppointmentDepositById };
